import axios from "axios";

const BASE_URL = "https://crm.careholding.it/ws";

const HEADERS_BASE = {
  "Content-Type": "application/json",
  AppId: "5C3FE37C-90B3-484E-A049-C6A42F6DCD2E",
  AppSecret: "787BD90B-C45F-4F75-8EBC-4565575921DC",
};

async function getToken() {
  const response = await fetch(`${BASE_URL}/auth/`, {
    method: "POST",
    headers: HEADERS_BASE,
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`Auth failed (${response.status}): ${text}`);
  }

  const data = await response.json();
  const token = data?.Token;

  if (!token) throw new Error("Auth response missing Token");

  return token;
}

export async function apiPost({ cat, met, np = 1, body }) {
  const token = await getToken();

  return axios.post(
    `${BASE_URL}/Call/?Cat=${cat}&met=${met}&np=${np}`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
        AppId: HEADERS_BASE.AppId,
        token,
      },
    }
  );
}

export async function apiGet({ cat, met, np = 1 }) {
  const token = await getToken();

  return axios.get(
    `${BASE_URL}/Call/?Cat=${cat}&met=${met}&np=${np}`,
    {
      headers: {
        "Content-Type": "application/json",
        AppId: HEADERS_BASE.AppId,
        token,
      },
    }
  );
}